export enum TipoComponenteAcao {
    SLIDE_TOGGLE,
    BUTTON,
    CLICK_LINE
}
